module.exports = __webpack_public_path__ + "img/3-March.d4597f64.jpg";